import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

function Header({ onOpenFilter }) {
    return (
        <Box
            component="header"
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 50,
                bgcolor: 'var(--paper)',
                borderBottom: '1px solid var(--line)',
                px: { xs: 2, md: 4 },
                py: { xs: '10px', md: '14px' },
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                flexShrink: 0,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <img src="/favicon.ico" alt="logo" width={38} height={38} style={{ borderRadius: 10, display: 'block' }} />
                <Box>
                    <Typography
                        component="div"
                        sx={{
                            fontFamily: 'var(--font-display)',
                            fontSize: { xs: 15, md: 18 },
                            fontWeight: 800,
                            lineHeight: 1.1,
                            letterSpacing: '0.02em',
                            color: 'var(--ink)',
                        }}
                    >
                        神戸<Box component="span" sx={{ color: 'var(--accent)' }}>グルメ</Box>マップ
                    </Typography>
                    <Typography
                        component="div"
                        sx={{
                            fontSize: { xs: 9, md: 10 },
                            color: 'var(--muted)',
                            letterSpacing: '0.12em',
                            mt: 0.25,
                        }}
                    >
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ flex: 1 }} />

            <IconButton
                onClick={onOpenFilter}
                size="small"
                aria-label="絞り込み"
                sx={{
                    color: 'var(--ink)',
                    bgcolor: 'var(--surface)',
                    borderRadius: '8px',
                    border: '1px solid var(--line)',
                    p: 0.75,
                    '&:hover': { bgcolor: 'var(--hero)', borderColor: 'var(--accent)' },
                }}
            >
                <TuneIcon fontSize="small" />
            </IconButton>
        </Box>
    );
}

export default Header;
